import React from "react";
import * as snackbarActions from "../../../actions/snackbarActions";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import PageTitle from "../../Utils/smsTitle";
import { SubHeader } from "../../../Containers/SubHeader";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faClipboardList,
  faFileExcel,
  faFilePdf
} from "@fortawesome/free-solid-svg-icons";
import MainSnackbar from "../../Utils/Snackbar/SmsSnackbar";
import CustomTable, {
  CustomTablePagination
} from "../../Utils/Tables/CustomTable";
import TableBody from "@material-ui/core/TableBody";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import { BackButton } from "../../Utils/Buttons/DataExportationButton";
import SelectInput, { CustomSelect } from "../../Utils/FormInputs/SelectInput";
import { useInsuranceSummary } from "./CustomHooks/useInsuranceSummary";
import { Container } from "../../Utils/styledComponents";
import {
  useExcelReports,
  usePdfDownload
} from "../../Utils/ReusableComponents/useExcelExport";
import { extractYearDigits, formatDateTime } from "../../Utils/ConvertDate";

const headData = [
  { id: "sl", numeric: false, disablePadding: false, label: "SL" },
  { id: "date", numeric: false, disablePadding: false, label: "Date" },
  { id: "invoice_number", numeric: false, disablePadding: false, label: "Invoice No" },
  { id: "claim_number", numeric: false, disablePadding: false, label: "Claim No." },
  { id: "card_number", numeric: false, disablePadding: false, label: "Membership No." },
  { id: "patient_number", numeric: false, disablePadding: false, label: "Patient No" },
  { id: "patient_name", numeric: false, disablePadding: false, label: "Patient Name" },
  { id: "sex", numeric: false, disablePadding: false, label: "Sex" },
  { id: "age", numeric: false, disablePadding: false, label: "Age" },
  { id: "account_name", numeric: false, disablePadding: false, label: "Provider Name" },
  { id: "scheme_name", numeric: false, disablePadding: false, label: "Scheme Name" },
  { id: "amount", numeric: false, disablePadding: false, label: "Amount" }
];

const InsuranceSummaryReport = ({ actions, snackbars }) => {
  const {
    state,
    handleChange,
    isPending,
    handleChangeActivePage,
    handleSubmit,
    handleCustomSearch,
    count,
    activePage,
    customSearch,
    data,
    closeSnackbar,
    submitted,
    loading,
    provider,
    providers,
    handleChangeProvider,
    page,
    rowsPerPage,
    handleChangeRowsPerPage,
    handleChangePage
  } = useInsuranceSummary(actions);

  const { start_date, end_date, status } = state;

  const params = {
    end_date,
    start_date,
    page: activePage,
    search: customSearch,
    status
  };

  const pdfObj = {
    file_name: "Insurance Summary List",
    url: "cbilling/insurance_summary_exports",
    params: { ...params, download_type: 2, provider_id: provider?.value }
  };

  const { exportPdf, isLoadingPdf } = usePdfDownload(actions, pdfObj);

  const { exportExcel, isLoading: isLoadingExcel } = useExcelReports(actions, {
    file_name: "Insurance Summary List",
    url: "cbilling/insurance_summary_exports",
    params: { ...params, download_type: 1, provider_id: provider?.value }
  });

  const { openBar, type, message } = snackbars;

  const isLoading = loading === "pending";
  const isSuccess = loading === "success";
  const isError = loading === "error";

  const pagination = (
    <CustomTablePagination
      colSpan={3}
      page={page}
      rowsPerPage={rowsPerPage}
      count={count}
      handleChangePage={handleChangePage}
      handleChangeRowsPerPage={handleChangeRowsPerPage}
      isTotalCount
    />
  );

  return (
    <div className="journals" data-testid="insurance-summary">
      <PageTitle title="Insurance Summary" />
      <SubHeader title="Reports" subTitle="Insurance Summary">
        <FontAwesomeIcon icon={faClipboardList} />
      </SubHeader>

      <Container className="mt-1">
        <MainSnackbar
          variant={type}
          open={openBar}
          message={message}
          handleCloseBar={closeSnackbar}
        />

        {/* ===== TOP SECTION ===== */}
        <div style={{ padding: "8px 0 0 0" }}>
          {/* Back + Export */}
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              flexWrap: "wrap",
              marginBottom: "12px",
              gap: "8px"
            }}
          >
            <BackButton
              text="Reports"
              to="/reports/generalreports"
              data-testid="product-sales-report-back-button"
            />

            <div style={{ display: "flex", gap: "8px" }}>
              <button
                type="button"
                onClick={exportExcel}
                disabled={isLoadingExcel}
                className="btn btn-sm text-white"
                style={{
                  backgroundColor: "#389081",
                  borderColor: "#389081",
                  height: "32px",
                  padding: "0 14px",
                  fontSize: "13px",
                  borderRadius: "6px"
                }}
              >
                <FontAwesomeIcon icon={faFileExcel} className="me-1" />
                {isLoadingExcel ? "Exporting..." : "Excel"}
              </button>
              <button
                type="button"
                onClick={exportPdf}
                disabled={isLoadingPdf}
                className="btn btn-sm text-white"
                style={{
                  backgroundColor: "#389081",
                  borderColor: "#389081",
                  height: "32px",
                  padding: "0 14px",
                  fontSize: "13px",
                  borderRadius: "6px"
                }}
              >
                <FontAwesomeIcon icon={faFilePdf} className="me-1" />
                {isLoadingPdf ? "Exporting..." : "PDF"}
              </button>
            </div>
          </div>

          {/* Filters – tight row */}
          <div
            style={{
              display: "flex",
              flexWrap: "wrap",
              alignItems: "center",
              gap: "10px",
              marginBottom: "14px"
            }}
          >
            <input
              type="date"
              name="start_date"
              value={start_date || ""}
              onChange={handleChange}
              className="form-control form-control-sm"
              style={{
                width: "145px",
                height: "32px",
                padding: "2px 8px",
                fontSize: "13px",
                borderRadius: "6px"
              }}
            />
            <input
              type="date"
              name="end_date"
              value={end_date || ""}
              onChange={handleChange}
              className="form-control form-control-sm"
              style={{
                width: "145px",
                height: "32px",
                padding: "2px 8px",
                fontSize: "13px",
                borderRadius: "6px"
              }}
            />

            <div style={{ minWidth: "150px" }}>
              <SelectInput
                value={status}
                onChange={handleChange}
                name="status"
                options={[
                  { value: 0, text: "All" },
                  { value: 2, text: "Complete" },
                  { value: 1, text: "Incomplete" },
                  { value: "ON_SMART", text: "ON SMART" },
                  { value: "OFF_SMART", text: "OFF SMART" }
                ]}
              />
            </div>

            <div style={{ minWidth: "200px" }}>
              <CustomSelect
                defaultValue={{ label: "Select provider...", value: "" }}
                id="insurance_provider"
                value={provider}
                options={providers}
                onChange={handleChangeProvider}
                isClearable
              />
            </div>

            <button
              type="button"
              onClick={handleSubmit}
              disabled={isPending}
              className="btn btn-sm text-white"
              style={{
                backgroundColor: "#389081",
                borderColor: "#389081",
                height: "32px",
                padding: "0 14px",
                fontSize: "13px",
                borderRadius: "6px"
              }}
            >
              {isPending ? "Loading..." : "Filter"}
            </button>
          </div>
        </div>

        {/* TABLE */}
        <CustomTable
          title=""
          handleChangeNextPage={handleChangeActivePage}
          term={customSearch}
          records={10}
          pagination={pagination}
          headData={headData}
          handler={handleCustomSearch}
          total_count={count}
          activePage={activePage}
          data={data}
          colSpan={headData.length}
          customPage
          searchPlaceHolder="Search patient, claim, invoice..."
        >
          <TableBody>
            {isLoading ? (
              <TableRow>
                <TableCell colSpan={headData.length} align="center">
                  <img src="/images/smsloader.gif" alt="loader" />
                </TableCell>
              </TableRow>
            ) : null}

            {isSuccess ? (
              data.length > 0 ? (
                data.slice(0, rowsPerPage).map((item, index) => {
                  const cnt = (activePage - 1) * rowsPerPage + index + 1;
                  const year = extractYearDigits(item.begin_datetime);
                  return (
                    <TableRow
                      hover
                      role="checkbox"
                      tabIndex={-1}
                      key={index}
                      className="mui-table-row"
                    >
                      <TableCell style={{ fontSize: "13px" }}>{cnt}</TableCell>
                      <TableCell style={{ fontSize: "13px" }}>
                        {item.begin_datetime
                          ? formatDateTime(item.begin_datetime)
                          : ""}
                      </TableCell>
                      <TableCell style={{ fontSize: "13px" }}>
                        {`${item?.visit_id}/${year}`}
                      </TableCell>
                      <TableCell style={{ fontSize: "13px" }}>
                        {item.claim_number}
                      </TableCell>
                      <TableCell style={{ fontSize: "13px" }}>
                        {item.card_number}
                      </TableCell>
                      <TableCell style={{ fontSize: "13px" }}>
                        {item.patient_number}
                      </TableCell>
                      <TableCell style={{ fontSize: "13px", fontWeight: 600 }}>
                        {`${item.patient_firstname} ${item.patient_lastname}`}
                      </TableCell>
                      <TableCell style={{ fontSize: "13px" }}>
                        {item.gender}
                      </TableCell>
                      <TableCell style={{ fontSize: "13px" }}>
                        {item.age}
                      </TableCell>
                      <TableCell style={{ fontSize: "13px" }}>
                        {item.provider_name}
                      </TableCell>
                      <TableCell style={{ fontSize: "13px" }}>
                        {item.scheme_name}
                      </TableCell>
                      <TableCell
                        style={{
                          fontSize: "13px",
                          fontWeight: 600,
                        //   color: "#027a5f"
                        }}
                      >
                        {item.total_amount}
                      </TableCell>
                    </TableRow>
                  );
                })
              ) : (
                <TableRow>
                  <TableCell colSpan={headData.length} align="center">
                    No records found
                  </TableCell>
                </TableRow>
              )
            ) : null}

            {isError ? (
              <TableRow>
                <TableCell colSpan={headData.length} align="center">
                  The server did not return a valid response
                </TableCell>
              </TableRow>
            ) : null}
          </TableBody>
        </CustomTable>
      </Container>
    </div>
  );
};

function mapStateToProps(state) {
  return { snackbars: state.snackbar };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: {
      snackbarActions: bindActionCreators(snackbarActions, dispatch)
    }
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(InsuranceSummaryReport);